import Cookies from 'js-cookie';

export const setCookies = (name: string, value: string, days?: number) => {
  Cookies.set(name, value, { expires: days });
};

export const getCookies = (name: string) => {
  return Cookies.get(name);
};

export const removeCookies = (name: string) => {
  return Cookies.remove(name);
};
